<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateModal from "./create_modal.vue";
import DeleteModal from "./delete_modal.vue"
import { globalStatus }  from "@/helpers/helper"

export default {
  page: {
    title: "Hat/Port Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CreateModal,
    DeleteModal,
  },
  filters:{
    
  },
  data() {
    return {
        title: "HAT/PORT LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "HAT/PORT LİSTESİ",
            active: true,
          },
        ],
        rowSelection:[],
        routerList:[],
        balanceList:[],
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "ports",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa',
          infoFn: (params) => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
         {
          label: 'Müşteri Kullanıcı Adı',
          field: 'username',
          width:'18%',
          filterOptions: {
            enabled: true,
            placeholder: 'Kullanıcı Adı Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Router Adı',
          field: this.routerAndIp,
          width:'18%',
          html: true,
          filterOptions: {
            customFilter: true
          }
        },
        {
          label: 'Balans Adı',
          field: 'balance_name',
          width: '18%',
          html: true,
          filterOptions: {
            balanceFilter: true
          }
        },
        {
          label: 'Hat Tipi',
          field: this.type,
          sortable: false,
          filterOptions: {
            enabled: false,
            placeholder: 'Balans Adı Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Port Başlangıç',
          field: 'start',
          sortable: false,
          tdClass:'text-end'
        },
        {
          label: 'Port Bitiş',
          field: 'end',
          sortable: false,
          tdClass:'text-end'
        },
        {
          label: 'Port Aralığı',
          field: 'interval',
          sortable: false,
          tdClass:'text-end',
        },
        {
          label: 'İp',
          field: 'ip',
          sortable: false,
          width: '110px',
          filterOptions: {
            enabled: true,
            placeholder: 'İp Filtrele',
            filterDropdownItems: [ ],
          },
        },
      ],
    };
  },
  mounted() {
    this.getRouters()
    this.getBalances()
    this.loadItems()
  },
  methods: {
    type(obj){
      return obj.type == 2 ? 'Metro' : 'Dsl' 
    },
    async getRouters(){
      await this.$http.post('/routers' , { output : 'only'})
      .then(resp => {
          this.routerList = resp.data
      })
      .catch(error => error)
    },
    async getBalances(){
      await this.$http.post('/ports/getBalances' )
      .then(resp => {
          this.balanceList = resp.data
      })
      .catch(error => error)
    },
    routerAndIp(rowObj){
        return `${rowObj.nasname}</br> ${rowObj.shortname}`
    },
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.meta.total,
              pageLength: res.data.meta.last_page,
              currentPage: res.data.meta.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(params) {
      this.selected = params.selectedRows.length
      this.rowSelection = '';
      params.selectedRows.forEach((e,i)=>{
          this.rowSelection += `${e.id}` + (i == this.selected-1 ? '' : ',');
      });
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
     },
     create(){
       this.$parent.$bvModal.show('modal-hat')
     },
    async hatlariBosalt(){
      this.$parent.$bvModal.show('delete-ip')
      /*
      await this.$http.delete(`/ports/empty?removeIds=${this.rowSelection}`)
            .then(() =>this.loadItems()) */
    },
    async hatlariSil(params = null){
      const removeIds = params.id ?? this.rowSelection
      await this.$http.delete(`/ports?removeIds=${removeIds}`)
            .then(() =>this.loadItems())
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <CreateModal 
      :routerList="routerList" 
      @loadItems="loadItems"
    />

    <DeleteModal 
      :routerList="routerList"
      @loadItems="loadItems"
    />


    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template slot="column-filter" slot-scope="{ column, updateFilters }">
                    <v-select 
                        v-if="column.filterOptions && column.filterOptions.customFilter"
                        :options="routerList"
                        :reduce="r => r.id"
                        @input="(value) => updateFilters(column, value)"
                        >
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                            {{ option.shortname  }} - {{ option.nasname  }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                            {{ option.shortname  }} - {{ option.nasname  }}
                            </div>
                          </template>
                      <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                    <v-select 
                        v-else-if="column.filterOptions && column.filterOptions.balanceFilter"
                        :options="balanceList"
                        :reduce="r => r.id"
                        @input="(value) => updateFilters(column, value)"
                        >
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                            {{ option.balance_name  }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                            {{ option.balance_name  }}
                            </div>
                          </template>
                      <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                </template> 
                <div slot="table-actions">
                  <div class="button-items">
                    <button 
                      class="btn btn-outline-danger" 
                      type="button" 
                      @click="hatlariBosalt()"
                      ><i class="text-danger mdi mdi-trash-can-outline"></i> Hatları Sil / Boşalt
                    </button>
                    <button 
                      class="btn btn-success" 
                      type="button" 
                      @click="create()"
                      ><i class="mdi mdi-plus"></i> Yeni Oluştur
                    </button>
                  </div>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                 <span
                    v-if="props.column.field === 'type'"
                    class="text-nowrap"
                  >
                    {{ props.row.type.toUpperCase() }}
                  </span>
                  
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>